module.exports = __webpack_public_path__ + "img/weekly-3.16e5a7a7.png";